<template>
    <project-step-container
            prev-to="js_deep_customer_empathy_5"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(6, 'empathy-map-guide')" ></LinkStyleGuide>
        <b-row class="first-form">
            <b-col cols="12" class="mt-4 simple-text" tabindex="0">
                {{getMessage(6, 'empathy-map-sub')}}
             </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(6, 'iam')}}</label>
                <input id="first-thing" type="text" v-model="form.iam"
                 :placeholder="getMessage(6, 'iamplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(6, 'tryingto')}}</label>
                <input id="second-thing" type="text" v-model="form.tryingto"
                 :placeholder="getMessage(6, 'tryingtoplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(6, 'but')}}</label>
                <input id="third-thing" type="text" v-model="form.but"
                 :placeholder="getMessage(6, 'butplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="four-thing">{{getMessage(6, 'because')}}</label>
                <input id="four-thing" type="text" v-model="form.because"
                 :placeholder="getMessage(6, 'becauseplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="five-thing">{{getMessage(6, 'emotions')}}</label>
                <input id="five-thing" type="text" v-model="form.emotions" 
                :placeholder="getMessage(6, 'emotionsplaceholder')"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {Storage, Project, ConflictSyn , StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"

    export default {
        name: "DeepCustomerEmpathy6",
        components: {ProjectStepContainer,  LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_CUSTOMER_PROBLEM,
                urlNextProject:'js_deep_customer_empathy_7',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.CUSTOMER_PROBLEM_STATEMENT_GUIDE),
                form: {
                    iam: "",
                    tryingto: "",
                    but: "",
                    because: "",
                    emotions: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            },
            openGuide() {
                this.$bvModal.show('project-style-guide')
            }
        }
    }
</script>

